import { Button, Col, Form, Input, Row, Select } from "antd";
import { convertPersian, validateInput } from "../../../../tools/tools";
import Iinput from "../../../auxiliary/inputs/Input";
import DatePicker from "../../../auxiliary/datepicker/datepicker";
import ReactInputMask from "react-input-mask";
import { useEffect, useState } from "react";
import OTP from "../../../auxiliary/otp-modal/otp";
import { CheckTokenWithOTP, setToken, setTokenOTP } from "../../../../tools/services";
import { useAPIPublic } from "../../../../tools/api";

const Profile = ({ t, setCreditCard, creditCard }) => {
	const { queryPayredJobs } = useAPIPublic();
	const [frmProfile] = Form.useForm();
	const [profile, setProfile] = useState({ buttonProgress: false, isOpenOtp: false, occupationList: [] });

	useEffect(() => {
		const loadOccupation = async () => {
			const res = await queryPayredJobs();
			if (res) setProfile((p) => ({ ...p, occupationList: res }));
		};
		loadOccupation();
	}, [creditCard]);

	useEffect(() => {
		if (creditCard?.profile) {
			frmProfile.setFieldsValue({
				passportNumber: creditCard?.profile.passportNumber,
				nationalId: creditCard?.profile?.nationalId,
				mothername: creditCard?.profile?.mothername,
				fathername: creditCard?.profile?.fathername,
				firstName: creditCard?.profile?.firstName,
				lastName: creditCard?.profile?.lastName,
				birthdate: creditCard?.profile?.birthdate,
				email: creditCard?.profile?.email,
				occupationid: creditCard?.profile?.occupationid,
				mobile: ((m) => ((m = String(m).replace(/^\+/, "")), m.startsWith("98") ? m : "98" + m))(creditCard?.profile?.mobile ?? ""),
			});
		} else {
			frmProfile.resetFields();
		}
	}, [profile.occupationList]);

	const submitHandler = async () => {
		try {
			const values = await frmProfile.validateFields();
			setProfile((p) => ({ ...p, buttonProgress: true, isOpenOtp: true }));
		} catch (err) {
			setProfile((p) => ({ ...p, buttonProgress: false, isOpenOtp: false }));
		}
	};

	const handleGetToken = async (token) => {
		setProfile((p) => ({ ...p, buttonProgress: false, isOpenOtp: false }));
		if (token) {
			console.log({ token });
			const values = await frmProfile.validateFields();
			const mobilePlain = String(values.mobile || "").replace(/\s+/g, "");
			await setTokenOTP({ expireUTCTime: token.expireUTCTime, token: token.token });
			const isTokenOTP = await CheckTokenWithOTP();
			if (isTokenOTP) {
				setTimeout(() => {
					setCreditCard((prev) => ({
						...prev,
						profile: { ...values, mobile: mobilePlain },
						step: 1,
					}));
				}, 2000);
			} else {
				console.log("خطا");
			}
		}
	};

	const rawMobile = String(frmProfile.getFieldValue("mobile") || "").replace(/\s+/g, "");
	const msisdnToSend = rawMobile.replace(/^98/, "");

	return (
		<>
			<div className="g-body-format-page">
				<h3 className="header-of-form">اطلاعات هویتی</h3>
				<div className="holder-form">
					<Form
						id="frmProfile"
						name="frmProfile"
						form={frmProfile}
						onFinish={submitHandler}
						layout="vertical"
						// اگر initialValues کلی داری می‌تونی اینجا هم ست کنی
						// initialValues={{ mobile: initialMsisdn || "" }}
					>
						<Row justify={"start"} gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="passportNumber"
									label="شماره پاسپورت"
									rules={[validateInput({ t, validate: true, type: "passport" })]}>
									<Iinput
										disabled={creditCard.type == "passportNumber"}
										maxLength={10}
										inputMode="numeric"
										dir="ltr"
										placeholder="شماره پاسپورت خود را وارد کنید"
									/>
								</Form.Item>
							</Col>

							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="nationalId" label="کدملی" rules={[validateInput({ t, validate: true, length: 10 })]}>
									<Iinput
										maxLength={10}
										disabled={creditCard.type == "nationalId"}
										inputMode="numeric"
										dir="ltr"
										placeholder="کدملی خود را وارد کنید"
									/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="firstName" label="نام" rules={[validateInput({ t, validate: true, type: "english" })]}>
									<Iinput />
								</Form.Item>
							</Col>

							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="lastName"
									label="نام خانوادگی"
									rules={[validateInput({ t, validate: true, type: "english" })]}>
									<Iinput />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="fathername" label="نام پدر" rules={[validateInput({ t, validate: true, type: "english" })]}>
									<Iinput />
								</Form.Item>
							</Col>

							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="mothername"
									label="نام مادر"
									rules={[validateInput({ t, validate: true, type: "english" })]}>
									<Iinput />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="birthdate"
									rules={[validateInput({ t, validate: true })]}
									label="تاریخ تولد"
									valuePropName="values"
									getValueFromEvent={(v) => v}>
									<DatePicker />
								</Form.Item>
							</Col>

							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="email"
									disabled={creditCard.type == "email"}
									label="پست الکترونیکی"
									rules={[validateInput({ t, validate: false, type: "email" })]}>
									<Input dir="ltr" inputMode="email" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={30}>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item
									className="input-normal"
									name="mobile"
									label={"شماره همراه"}
									rules={[validateInput({ t, validate: true, type: "msisdn_global" })]}
									getValueFromEvent={(e) => {
										const raw = e?.target?.value ?? "";
										return String(convertPersian(raw)); // ⬅️ مهم: تبدیل به primitive
									}}>
									<ReactInputMask mask={"\\98\\999 999 99 99"} dir="ltr" className="msisdn-mask">
										{(inputProps) => <Input {...inputProps} inputMode="numeric" />}
									</ReactInputMask>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={12} lg={10} xl={8}>
								<Form.Item className="input-normal" name="occupationid" label="شغل" rules={[validateInput({ t, validate: true })]}>
									<Select placeholder="شغل">
										{profile.occupationList.map((type, key) => (
											<Select.Option key={key} value={type.value}>
												{type.name}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</div>
			</div>

			<OTP
				isOpen={profile.isOpenOtp}
				planid={process.env.REACT_APP_PLANID_ASSAIN_CARD_TURKEY}
				callback={handleGetToken}
				certno={frmProfile.getFieldValue("nationalId")}
				checkmsisdnvcertno={true}
				expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
				msisdn={msisdnToSend}
				sessionid={Date.now()}
			/>

			<div className="g-footer-format-page">
				<div className="holder-button">
					{/* ✅ دکمه submit واقعی */}
					<Button className="btn-normal btn-aptel" loading={profile.buttonProgress} type="primary" htmlType="submit" form="frmProfile">
						مرحله بعد
					</Button>

					<Button type="default" className="btn-normal " onClick={() => setCreditCard({ ...creditCard, step: null })}>
						بازگشت
					</Button>
				</div>
			</div>
		</>
	);
};

export default Profile;
